export default __webpack_public_path__ + "static/media/my-image.aaa7e98b.jpg";